import axiosInstance from 'plugins/axios';
import { IBodyResponse } from 'types/type.global';

// ==================== INTERFACES ====================

// Quota Condition Attributes
export interface IQuotaConditionAttributes {
    id: number;
    quota_id: number;
    question_id: number;
    answer_option_id: number;
    created_at: string;
    updated_at: string;
}

// Quota Condition Item từ API response
export interface IQuotaConditionItem {
    id: string;
    type: string;
    attributes: IQuotaConditionAttributes;
}

// Quota Attributes (raw từ API)
export interface IQuotaAttributes {
    id: number;
    survey_id: number;
    question_page_id: number | null;
    name: string;
    limit: number;
    filled_quantity: number;
    status: 'active' | 'inactive';
    created_at: string;
    updated_at: string;
    quota_conditions?: IQuotaConditionAttributes[];
}

// Quota Item từ API response
export interface IQuotaItem {
    id: number;
    type: string;
    attributes: IQuotaAttributes;
}

// ==================== PAYLOADS ====================

// Payload để tạo quota condition
export interface ICreateQuotaConditionPayload {
    question_id: number;
    answer_option_id: number;
}

// Payload để tạo quota
export interface ICreateQuotaPayload {
    quota: {
        survey_id: number;
        question_page_id?: number | null;
        name: string;
        limit: number;
        conditions: ICreateQuotaConditionPayload[];
    };
}

// Payload để update quota status
export interface IUpdateQuotaPayload {
    quota: {
        status: 'active' | 'inactive';
    };
}

// ==================== RESPONSES ====================

// Response danh sách quota
export interface IQuotasResponse {
    quotas: IQuotaItem[];
}

/**
 * Lấy danh sách quota của survey
 * @param surveyId - ID của survey
 * @param questionPageId - (Optional) ID của question_page
 */
export const getQuotas = async (
    surveyId: number,
    questionPageId?: number
): Promise<IBodyResponse<IQuotasResponse>> => {
    let url = `admin/quotas?survey_id=${surveyId}`;

    if (questionPageId) {
        url += `&question_page_id=${questionPageId}`;
    }

    const response = await axiosInstance.get(url);
    return response.data;
};

/**
 * Tạo quota mới
 * @param payload - Payload chứa thông tin quota và điều kiện
 */
export const createQuota = async (
    payload: ICreateQuotaPayload
): Promise<IBodyResponse<IQuotaItem>> => {
    const response = await axiosInstance.post('admin/quotas', payload);
    return response.data;
};

/**
 * Cập nhật trạng thái quota
 * @param quotaId - ID của quota
 * @param payload - Payload chứa status mới
 */
export const updateQuotaStatus = async (
    quotaId: number,
    payload: IUpdateQuotaPayload
): Promise<IBodyResponse<IQuotaItem>> => {
    const response = await axiosInstance.patch(
        `admin/quotas/${quotaId}`,
        payload
    );
    return response.data;
};
